/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useEffect, useState } from "react";
import {
  EcommerceFlow,
  ExclusiveFlow,
  POSFlow,
  SuiFrensFlow,
  toastMessage,
  useGlobalMerchant
} from "utils/helper";
import { getSingleOrderProduct } from "apiServices/app";
import ECEProductComponent from 'components/Ecommerce/ECTheme/ECExclusive/ECEProductComponent';
import ECAProductComponent from 'components/Ecommerce/ECTheme/ECAdvance/ECAProductComponent';
import ECSProductComponent from 'components/Ecommerce/ECTheme/ECSuiFrens/ECSProductComponent';
import ECSPDetailComponent from 'components/Ecommerce/ECTheme/ECSuiFrens/ECSPDetailComponent';
import POSProductComponent from 'components/POS/POSProductComponent';
import { useBasket } from "containers/POSContainer/constant";

const ProductListComponent = ({
  viewName,
  productList,
  catClick,
  setCatClick,
  newOne,
  setNewOne,
}: any) => {
  const { ecommerceContent, isEndsWithSlash } = useGlobalMerchant();
  const { addToBasket, addToExistingBasket, removeFromBasket, itemList } = useBasket();
  const [isHaveSubCategory, setIsHaveCategory] = useState(false);
  const [filterProductList, setFilterProductList] = useState<any[]>([]);
  const [labelList, setLabelList] = useState<string[]>([]);
  const [addedToCart, setAddedToCart] = useState<{ [productId: string]: boolean; }>({});

  const renderMainContent = (viewName: any) => {
    switch (viewName) {
      case POSFlow:
        return (
          <POSProductComponent
            isHaveSubCategory={isHaveSubCategory}
            catClick={catClick}
            handleSubCategoryClick={handleSubCategoryClick}
            filterProductList={filterProductList}
            addedToCart={addedToCart}
            handleCartAction={handleCartAction}
            labelList={labelList}
          />
        );
      case EcommerceFlow:
        return (
          <ECAProductComponent
            isHaveSubCategory={isHaveSubCategory}
            catClick={catClick}
            handleSubCategoryClick={handleSubCategoryClick}
            filterProductList={filterProductList}
            addedToCart={addedToCart}
            handleCartAction={handleCartAction}
          />
        );
      case ExclusiveFlow:
        return (
          <ECEProductComponent
            filterProductList={filterProductList}
            handleCartAction={handleCartAction}
            addedToCart={addedToCart}
          />
        );
      case SuiFrensFlow:
        return (
          <>
            {isEndsWithSlash ? (
              <ECSPDetailComponent
                addedToCart={addedToCart}
                setAddedToCart={setAddedToCart}
              />
            ) : (
              <ECSProductComponent
                filterProductList={filterProductList}
                handleCartAction={handleCartAction}
                addedToCart={addedToCart}
                ecommerceContent={ecommerceContent}
              />
            )}
          </>
        );
      default:
        return (
          <ECAProductComponent
            isHaveSubCategory={isHaveSubCategory}
            catClick={catClick}
            handleSubCategoryClick={handleSubCategoryClick}
            filterProductList={filterProductList}
            addedToCart={addedToCart}
            handleCartAction={handleCartAction}
          />
        );
    }
  };

  const handleCartAction = (productId: string, product: any) => {
    addedToCart[productId] ? removeFromCart(productId) : addToCart(productId, product);
  };

  const onExistingBasket = (productId: string, product: any, qty: any) => {
    addToExistingBasket(product, qty);
    setAddedToCart((prevAddedToCart) => ({ ...prevAddedToCart, [productId]: true, }));
  };

  const addToCart = (productId: string, product: any) => {
    addToBasket(product);
    setAddedToCart((prevAddedToCart) => ({ ...prevAddedToCart, [productId]: true, }));
    toastMessage("Item added to basket");
  };

  const removeFromCart = (productId: string) => {
    removeFromBasket(productId);
    setAddedToCart((prevAddedToCart) => ({ ...prevAddedToCart, [productId]: false, }));
    toastMessage("Item removed from basket");
  };

  const handleSubCategoryClick = (clickedCategory: any) => {
    setCatClick(clickedCategory);
    setNewOne(2);
  };

  const onGetSingleProductOrder = (getOrderKey: any) => {
    try {
      getSingleOrderProduct(getOrderKey)
        .then((response) => {
          const responseData = response.data || response;
          if (responseData !== null && responseData.success !== false) {
            if (responseData && responseData.length > 0) {
              const productIdsWithQty = responseData.map((product: any) => ({ id: product.product_id, qty: product.qty, }));
              productList.forEach((product: any) => {
                const matchingProduct = productIdsWithQty.find((item: any) => item.id === product.product_id);
                matchingProduct && onExistingBasket(product.product_id, product, matchingProduct.qty);
              });
            }
          } else { toastMessage("You dont have any profile"); }
        })
        .catch((error) => { console.log(error); });
    } catch (error: any) { }
  };

  useEffect(() => {
    if (catClick && catClick.category_id) {
      setIsHaveCategory(false);
      if (catClick.category_id === 99001) {
        setFilterProductList(productList);
      } else if (catClick && catClick.sub_categories && catClick.sub_categories.length > 0) {
        newOne === 1 ? setLabelList([catClick.category_name]) : setLabelList([...labelList, catClick.category_name]);
        setIsHaveCategory(true);
        setFilterProductList([]);
      } else {
        const filteredProducts = productList.filter((product: any) => {
          return product.categories.some((category: any) => {
            return category.name === catClick.category_name;
          });
        });
        setFilterProductList(filteredProducts);
        setIsHaveCategory(false);
      }
    }
  }, [catClick]);

  useEffect(() => {
    const getPathname = window.location.pathname;
    if (getPathname === "/order") {
      const searchParams = new URLSearchParams(window.location.search);
      if (searchParams && searchParams.size == 1) {
        const abc = searchParams.get("id");
        abc !== "" && onGetSingleProductOrder(abc);
      }
    } else {
      productList.forEach((filter: any) => {
        // Assuming you want to check if there is a matching item in itemList
        const hasMatchingItem = itemList.some((item: any) => item.product.product_id === filter.product_id);
        hasMatchingItem && setAddedToCart((prevAddedToCart) => ({ ...prevAddedToCart, [filter.product_id]: true, }));
      });
    }
  }, []);

  return (
    <>{renderMainContent(viewName)}</>
  );
};

export default ProductListComponent;
